import React from 'react';

/**
 * Shared source-link block for Adult ADHD SSI info tooltips.
 *
 * Domains of Functional Impairment and "Settings in which this symptom
 * occurs" both cite the same three guidelines. Keeping the markup here
 * means the URLs and visual treatment cannot drift apart.
 */
export default function SsiGuidelineSources() {
  return (
    <div className="border-t border-gray-600 pt-2">
      <p className="text-gray-300 text-xs font-semibold mb-1">Sources</p>
      <ul className="space-y-1 list-disc list-inside">
        <li className="text-xs"><a href="https://icd.who.int/browse/2026-01/mms/en#821852937" target="_blank" rel="noreferrer" className="text-blue-300 underline hover:text-blue-100">ICD-11</a></li>
        <li className="text-xs"><a href="https://www.nice.org.uk/guidance/ng87" target="_blank" rel="noreferrer" className="text-blue-300 underline hover:text-blue-100">NICE NG87</a></li>
        <li className="text-xs"><a href="https://www.ncbi.nlm.nih.gov/books/NBK519712/table/ch3.t3/" target="_blank" rel="noreferrer" className="text-blue-300 underline hover:text-blue-100">DSM-5</a></li>
      </ul>
    </div>
  );
}
